import { matchPath } from 'react-router-dom';
import { getFeatureFlags } from 'utils/feature-flags';
import urls from './urls';

/**
 * List of pages that handle payment.
 *
 * This list is used to remove 3rd party scripts, except for those that process payment
 */
export const paymentPages = [urls.resolveOrderPayment]; // TODO Remove when checkout_excludeExternal is finally removed ane enabled by default
export const allPaymentPages = [urls.resolveOrderPayment, urls.checkout];

export function isPaymentPage(url: string | null | undefined) {
  if (!url) {
    return false;
  }
  const pathname = url.split('?', 2)[0];
  const { checkout_excludeExternal: excludeExternal } = getFeatureFlags() ?? {};

  return (excludeExternal ? allPaymentPages : paymentPages).some(path =>
    matchPath({ path }, pathname),
  );
}
